import { Box, List, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { Device } from 'src/api/device/types';
import { Button } from 'src/components/Button';
import { Status } from 'src/components/Status/status';

type Props = {
  device: Device;
  onRestartClick: () => void;
};

export const DeviceDetails: FC<Props> = memo(({ device, onRestartClick }) => (
  <>
    <Text fw={500} size="lg">
      Device Details
    </Text>

    <List spacing="xs" listStyleType="none">
      <List.Item>
        <Text size="xs">
          Playwall ID:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {device?.playwall_id}
          </Text>
        </Text>
      </List.Item>
      <List.Item>
        <Text size="xs">
          Hardware ID:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {device?.hardware_id}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Box display="flex" style={{ alignItems: 'center', gap: '8px' }}>
          <Text size="xs">Status: </Text>
          <Status status={device?.status} />
        </Box>
      </List.Item>

      <List.Item>
        <Box display="flex" style={{ alignItems: 'center', gap: '8px' }}>
          <Text size="xs">Restart: </Text>
          <Button size="sm" round variant="outline" onClick={onRestartClick}>
            RESTART DEVICE
          </Button>
        </Box>
      </List.Item>
    </List>
  </>
));

DeviceDetails.displayName = 'DeviceDetails';
